import { useTranslation } from "react-i18next";
import {
  createProductCategoryService,
  deleteProductCategoryService,
  getAllProductCategoriesService,
  updateProductCategoryService,
} from "../../services/Product/ProductCategory/ProductServices";
import { deleteProductService } from "../../services/Product/ProductServices";
import AdminNamedEntityList from "./AdminNamedEntityList";

const AdminProductCategories = () => {
  const { t } = useTranslation(["common"]);

  return (
    <AdminNamedEntityList
      title={t("common:productCat")}
      getAllService={getAllProductCategoriesService}
      createService={createProductCategoryService}
      updateService={updateProductCategoryService}
      deleteService={deleteProductCategoryService}
      deleteProductService={deleteProductService}
      productMatchesEntity={(product, entityId) => product.category?._id === entityId}
    />
  );
};

export default AdminProductCategories;
